
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DynamicScriptLoaderService } from './dynamicScriptLoader.service';
import { BehaviorSubject } from 'rxjs';
declare const leaflet: any;
@Injectable({
    providedIn: 'root',
})
export class MapService {
    public L: any = null;
    private mapObserver: BehaviorSubject<any>;
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private dynamicScriptLoader: DynamicScriptLoaderService
    ) {
        this.mapObserver = new BehaviorSubject(undefined);
        if (isPlatformBrowser(this.platformId)) {
            this.dynamicScriptLoader.load('leaflet').then(data => {
                this.L = leaflet;
                this.mapObserver.next(this.L);
            }).catch(error => console.log(error));
        }
    }

    get Leaflet$() {
        return this.mapObserver.asObservable();
    }

    get Leaflet() {
        if (!this.L) {
            setTimeout(() => {
                return this.L;
            }, 200);
        } else {
            return this.L;
        }
    }
}
